"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _react = _interopRequireDefault(require("react"));
var _sbUtils = require("@simplybenefits/sb-utils");
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _theme = require("../../../theme");
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable no-eval */

/**
 * Confirmation component displaying product details and pricing information.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.member - Information about the member.
 * @param {Object} props.product - Information about the selected product.
 * @param {Object} props.purchaseData - Information about the purchase, including coverage and premiums.
 * @param {Object} props.whitelabel - Whitelabel information for styling.
 * @returns {JSX.Element} - The rendered Confirmation component.
 */
var Confirmation = function Confirmation(_ref) {
  var member = _ref.member,
    product = _ref.product,
    purchaseData = _ref.purchaseData,
    whitelabel = _ref.whitelabel;
  var styles = {
    totalBlock: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  };
  var date = new Date();
  var effectiveDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
  var premium = purchaseData.primary.premium + (purchaseData.child ? purchaseData.child.premium : 0) + (purchaseData.spouse ? purchaseData.spouse.premium : 0) + (purchaseData.dependent ? purchaseData.dependent.premium : 0);
  var PST = product.calculations.taxes ? eval(product.calculations.taxes.PST[member.province]) : null;
  var RST = product.calculations.taxes ? eval(product.calculations.taxes.RST[member.province]) : null;
  var GST = product.calculations.taxes ? eval(product.calculations.taxes.GST[member.province]) : null;
  var HST = product.calculations.taxes ? eval(product.calculations.taxes.HST[member.province]) : null;
  var name = "".concat(product.type.toUpperCase() === 'VOLUNTARY' ? _i18n["default"].t(_tokens["default"].labels.marketplace.voluntary) : _i18n["default"].t(_tokens["default"].labels.marketplace.optional), " ").concat(product.name.primary[member.language]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true
  }, product.type.toUpperCase() === 'VOLUNTARY' ? _i18n["default"].t(_tokens["default"].labels.marketplace.reviewProductDetailsVoluntary) : _i18n["default"].t(_tokens["default"].labels.marketplace.reviewProductDetailsOptional)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    mediumLarge: true,
    bold: true,
    margin: "20px 0 10px 0",
    color: whitelabel.primaryColor || _theme.colors.skyBlue
  }, name), product.verbiages.confirmation.primaryNote && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    margin: "0 0 20px 0"
  }, product.verbiages.confirmation.primaryNote[member.language]), product.pricingType === 'variable' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
    variant: "middle",
    style: {
      margin: "10px 0"
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true
  }, "".concat(member.firstname, " ").concat(member.lastname)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.marketplace.pricingInCoverage, {
    pricing: _sbUtils.helpers.formatNumber(purchaseData.primary.volume, 0, true)
  }))), purchaseData.dependent && purchaseData.dependent.premium > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
    variant: "middle",
    style: {
      margin: "10px 0"
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.marketplace.dependentCoverage)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.marketplace.pricingInCoverage, {
    pricing: _sbUtils.helpers.formatNumber(purchaseData.dependent.volume, 0, true)
  })))), purchaseData.spouse && purchaseData.spouse.premium > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
    variant: "middle",
    style: {
      margin: "10px 0"
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.marketplace.spouseCoverage)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.marketplace.pricingInCoverage, {
    pricing: _sbUtils.helpers.formatNumber(purchaseData.spouse.volume, 0, true)
  })))), purchaseData.child && purchaseData.child.premium > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
    variant: "middle",
    style: {
      margin: "10px 0"
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.marketplace.childCoverage)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.marketplace.pricingInCoverage, {
    pricing: _sbUtils.helpers.formatNumber(purchaseData.spouse.volume, 0, true)
  }))))), /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
    variant: "middle",
    style: {
      margin: "10px 0"
    }
  }), (PST > 0 || RST > 0 || GST > 0 || HST > 0) && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.totalBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true
  }, "Subtotal"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 1,
      alignItems: 'flex-end'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true
  }, _sbUtils.helpers.formatNumber(premium, 2, true)))), PST > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.totalBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true
  }, _i18n["default"].t(_tokens["default"].labels.invoices.pst)), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 1,
      alignItems: 'flex-end'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true
  }, _sbUtils.helpers.formatNumber(PST, 2, true)))), RST > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.totalBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true
  }, _i18n["default"].t(_tokens["default"].labels.invoices.pst)), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 1,
      alignItems: 'flex-end'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true
  }, _sbUtils.helpers.formatNumber(RST, 2, true)))), GST > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.totalBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true
  }, _i18n["default"].t(_tokens["default"].labels.marketplace.gst)), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 1,
      alignItems: 'flex-end'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true
  }, _sbUtils.helpers.formatNumber(GST, 2, true)))), HST > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.totalBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true
  }, _i18n["default"].t(_tokens["default"].labels.marketplace.hst)), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 1,
      alignItems: 'flex-end'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true
  }, _sbUtils.helpers.formatNumber(HST, 2, true))))), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.totalBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    mediumLarge: true,
    bold: true
  }, "Total"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 1,
      alignItems: 'flex-end'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    mediumLarge: true,
    bold: true
  }, _sbUtils.helpers.formatNumber(premium + Number(PST) + Number(RST) + Number(GST) + Number(HST), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    margin: "0 0 3px 0"
  }, _i18n["default"].t(_tokens["default"].labels.marketplace.perMonth)))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    margin: "10px 0"
  }, _i18n["default"].t(_tokens["default"].labels.marketplace.benefitsEffectiveDateInfo), " ", /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'bold'
    }
  }, dates.getLocalDisplay(effectiveDate, "ll", _i18n["default"].locale))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    margin: "10px 0"
  }, product.type.toUpperCase() === 'VOLUNTARY' ? _i18n["default"].t(_tokens["default"].labels.marketplace.paymentWithdrawalInfoVoluntary) : _i18n["default"].t(_tokens["default"].labels.marketplace.paymentWithdrawalInfoOptional)), product.verbiages.confirmation.paymentNote && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    margin: "10px 0"
  }, product.verbiages.confirmation.paymentNote[member.language]));
};
var _default = exports["default"] = Confirmation;